module.exports = __webpack_public_path__ + "static/media/08.b5c97802.jpeg";